import React, { useState, useEffect, useRef, useCallback } from 'react';
import syncRowHeights from '../../../helpers/syncRowHeights';

export const GenericTable = ({ title, rows, data, paginationData, loading, restorePostcode, index = 0, cycleIndex, customPostcode, searchEnabled, setPostcodeModal, handleInputChange, userInput, toggle, additionalHeaderInfo }) => {
    const [localInput, setLocalInput] = useState(userInput);
    const memoizedHandleInputChange = useCallback(handleInputChange, []);
    return (
        <div style={{ height: 'fit-content' }}>
            <table className="table borders squish smaller-text left sync scale-text" style={{ height: '100%', tableLayout: 'fixed', wordBreak: 'break-word' }}>
                <thead>
                    <tr>
                        <th colSpan={2}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {title}
                                <div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
                                    {additionalHeaderInfo && (
                                        additionalHeaderInfo.map(text => {
                                            return <span>{text}</span>
                                        })
                                    )}
                                    {customPostcode && (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <span className='fas fa-trash-undo' onClick={() => { restorePostcode() }} title="Restore original postcode search"></span>
                                        </div>
                                    )}
                                    {toggle &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <span className='fas fa-rotate-reverse' onClick={() => toggle()}></span>
                                        </div>
                                    }
                                    {searchEnabled &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <span className='fas fa-search' onClick={() => setPostcodeModal(true)} title="Search for a different postcode"></span>
                                        </div>
                                    }
                                    {
                                        (paginationData?.total ?? data?.length) > 0 ? <>
                                            <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <span className='fas fa-angle-left' onClick={() => cycleIndex(-1)}></span>
                                                <span style={{ minWidth: '5em', textAlign: 'center' }}>
                                                    {
                                                        paginationData ?
                                                            `${(paginationData.per_page * (paginationData.current_page - 1)) + index + 1}`
                                                            : index + 1
                                                    }
                                                    /{paginationData?.total ?? data.length}
                                                </span>
                                                <span className='fas fa-angle-right' onClick={() => cycleIndex(1)}></span>
                                            </span>
                                        </> : null
                                    }
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => {
                        return (
                            <tr key={i}>{
                                row.map((Cell, rowIndex) => {
                                    const cellAbove = row[rowIndex - 1]
                                    if (!Cell && typeof cellAbove === "function") return
                                    return (
                                        <td key={rowIndex} rowSpan={typeof Cell === "function" && !row[rowIndex + 1] ? 2 : 1} colSpan={row.length === 1 ? 2 : 1} style={{ minWidth: '60px', textAlign: (loading && rowIndex === 1) || row.length === 1 ? 'center' : 'unset', borderBottom: '0px', color: data?.[index]?.Font_Colour && rowIndex === 1 && i === 0 ? data?.[index]?.Font_Colour : 'unset' }}>
                                            {loading && rowIndex === 1 && i === 0 ?
                                                <i className="fa fa-spinner fa-spin"></i>
                                                :
                                                loading && rowIndex === 1 && typeof Cell === "string" ?
                                                    ''
                                                    :
                                                    typeof Cell === "string" ?
                                                        rowIndex === 0 && row.length !== 1 ? Cell : Array.isArray(data) ? data?.[index]?.[Cell] : data?.[Cell]
                                                        : Cell?.hasInput ?
                                                            <input
                                                                disabled={Cell.disabled}
                                                                type="text"
                                                                value={localInput[Cell.column] ?? Cell.value ?? ''}
                                                                onChange={e => handleInputChange({ [Cell.column]: e.target.value })}
                                                            />
                                                            : Cell?.hasTextArea ?
                                                                <TableTextArea textareaValue={localInput[Cell.column]} handleInputChange={memoizedHandleInputChange} index={i} column={Cell.column} value={Cell.value} disabled={Cell.disabled} />
                                                                : Cell?.hasDropdown ?
                                                                    // <select value={Cell.value ?? ''} onChange={ e => setUserInput((prev) => ({ ...prev, GISX: e.target.value })) }>
                                                                    <select disabled={Cell.disabled} value={Cell.value ?? ''} onChange={e => handleInputChange({ [Cell.column]: e.target.value })}>
                                                                        {
                                                                            Cell?.options?.map(option => {
                                                                                return (
                                                                                    <option value={option.value}>{option.value}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    : Cell ?
                                                                        <Cell />
                                                                        : ''
                                            }
                                        </td>
                                    )
                                })
                            }</tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

const TableTextArea = ({ textAreaValue, column, value, disabled, handleInputChange }) => {
    const textareaRef = useRef(null);
    const [heightRecord, setHeightRecord] = useState()

    useEffect(() => {
        textareaRef.current.style.height = "1.5em"
        textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"
        if (textareaRef.current.style.height !== heightRecord) {
            setHeightRecord(textareaRef.current.style.height)
            syncRowHeights()
        }
    }, [value])

    return (
        <textarea style={{ resize: 'none', overflow: 'hidden', height: '1.5em', width: '100%', verticalAlign: 'middle' }}
            disabled={disabled}
            value={textAreaValue?.[column] ?? value ?? ''}
            ref={textareaRef}
            onChange={(e) => {
                e.target.style.height = "1.5em";
                e.target.style.height = e.target.scrollHeight + "px"
                handleInputChange({ [column]: e.target.value })
            }}
        />
    )
}
